import React from 'react';
import styled from '@emotion/styled';
import PivotPointContent from './phases/PivotPointContent';

const Banner = styled.div`
  margin: 0 0 12px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(76, 175, 80, 0.35);
  background: rgba(76, 175, 80, 0.08);
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  line-height: 1.5;
`;

/**
 * Facilitator-authored pivot points — no impact map required.
 * Reuses PivotPointContent CRUD (RAG manual pivot API).
 */
export default function ManualPivotAdmin({ instanceId, locked = false }) {
  return (
    <div>
      <Banner>
        <strong>Manual pivot points.</strong> This workshop has no impact map. Add pivot points
        below (title + description). Good descriptions help AI in Lenses and Solutions.
      </Banner>
      <PivotPointContent instanceId={instanceId} locked={locked} />
    </div>
  );
}
